import { createFileRoute } from "@tanstack/react-router";
import PopularCardsSectionSettings from "@/pages/admin/PopularCardsSectionSettings";

export const Route = createFileRoute("/admin/popular-cards-section")({
  component: PopularCardsSectionSettings,
});
